export enum GameSessionPromotionStates {
    INIT = 'init',
    RESTORE = 'restore',
    START = 'start',
    IN_PROGRESS = 'inProgress',
    END = 'end',
    DISABLED = 'disabled'
}
